import { ChangeDetectionStrategy, Component } from '@angular/core';

let nextId = 0;

/**
 * The app mark: a calendar with a gear and a green check — the shift that got
 * scheduled.
 *
 * Decorative by design (`aria-hidden`), the accessible name comes from
 * whatever it sits beside — `ui-brand` carries it. The size follows the host's
 * font-size, so a call site picks it with a text utility —
 * `<ui-logo class="text-3xl" />`.
 */
@Component({
  selector: 'ui-logo',
  standalone: true,
  templateUrl: './ui-logo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'aria-hidden': 'true', class: 'inline-block' },
})
export class UiLogoComponent {
  /** The two `<mask>`s are referenced by id, and an id must not repeat in a document. */
  private readonly uid = `ui-logo-${nextId++}`;
  readonly calendarMaskId = `${this.uid}-calendar`;
  readonly gearMaskId = `${this.uid}-gear`;

  /** The eight teeth each circle is drawn from, at 45° steps. */
  readonly teeth = [0, 45, 90, 135, 180, 225, 270, 315];
}
